let dates = [
    ("Sep 15, 2022 - Oct 15, 2022"),
    ("Oct 15, 2022 - Nov 14, 2022"),
    ("Nov 14, 2022 - Dec 14, 2022"),
    ("Dec 14, 2022 - Jan 14, 2023"),
    ("Jan 14, 2023 - Feb 13, 2023"),
    ("Feb 13, 2023 - Mar 15, 2023"),
    ("Mar 15, 2023 - Apr 15, 2023"),
    ("Apr 15, 2023 - May 15, 2023"),
    ("May 15, 2023 - Jun 14, 2023"),
    ("Jun 14, 2023 - Jul 15, 2023"),
    ("Jul 15, 2023 - Aug 14, 2023"),
    ("Aug 14, 2023 - Sep 13, 2023"),
    ("Sep 13, 2023 - Oct 14, 2023"),
    ("Oct 14, 2023 - Nov 13, 2023"),
    ("Nov 13, 2023 - Dec 13, 2023"),
    ("Dec 13, 2023 - Jan 13, 2024"),
    ("Jan 13, 2024 - Feb 13, 2024"),
    ("Feb 13, 2024 - Mar 13, 2024"),
    ("Mar 13, 2024 - Apr 13, 2024"),
    ("Apr 13, 2024 - May 14, 2024"),
    ("May 14, 2024 - June 1, 2024")
]

export default dates;